import {
  beBeeCountSavedRows,
  beBeeDeleteSavedRows,
  beBeeGetSavedRow,
  beBeeGetSavedRows,
  beBeeServiceAddSavedRow,
  beBeeUpdateSavedRows
} from 'Api/beBeeServiceApi'
import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

export async function fetchSavedRows() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  // TODO per ora idCategory è 0 - modificare quando verranndo implementate le categorie
  const resp = await beBeeGetSavedRows(idList, 0)

  const ret = resp.Items.map((m) => {
    const x = JSON.parse(m.Json)
    x.metadata.id = m.IdRow
    return x
  })
  return ret
}

export async function createSavedRow(row) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const ret = await beBeeServiceAddSavedRow(idList, {
    Name: row.metadata.name,
    IdCategory: 0,
    Json: JSON.stringify(row)
  })

  return ret
}

export async function updateSavedRow(row) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const saveRow = await beBeeGetSavedRow(idList, row.metadata.id)

  const newJson = JSON.parse(saveRow.Json)
  newJson.metadata.name = row.metadata.name
  newJson.metadata.id = row.metadata.id

  const ret = await beBeeUpdateSavedRows(idList, row.metadata.id, {
    Name: row.metadata.name,
    Json: JSON.stringify(newJson)
  })

  return ret
}

export async function deleteSavedRow(id) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  await beBeeDeleteSavedRows(idList, id)
}

export async function countSavedRows(idCategory) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const ret = await beBeeCountSavedRows(idList, idCategory)

  return ret
}
